import TreatmentPage from "./TreatmentPage";

export default function Microneedling() {
  return (
    <TreatmentPage
      title="Microneedling"
      heroImage="/Treatment/microneedling-drtruptis-clinic.jpeg"
      intro="Microneedling is a minimally invasive skin rejuvenation treatment that uses tiny sterile needles to create controlled micro-injuries in the skin. These microchannels stimulate the natural production of collagen and elastin, helping the skin repair itself and become smoother, firmer, and healthier."

      description="Microneedling is commonly used to treat acne scars, enlarged pores, uneven skin texture, pigmentation, and early signs of aging. It is a safe and effective treatment suitable for most skin types."

      howItWorks="A specialized microneedling device with fine needles creates tiny punctures on the skin surface. This controlled stimulation activates the skin’s natural healing process, boosting collagen production and improving overall skin texture and tone."

      benefits={[
        "Reduces acne scars and blemishes.",
        "Improves skin texture and smoothness.",
        "Minimizes enlarged pores.",
        "Reduces fine lines and wrinkles.",
        "Improves skin tone and pigmentation.",
        "Boosts natural collagen production."
      ]}

      beforeAfterImages={[
        "/Treatment/before-microneedling-drtruptis-clinic.jpg",
        "/Treatment/after-microneedling-drtruptis-clinic.jpg",
      ]}

      faqs={[
        { q: "Is microneedling painful?", a: "A numbing cream is applied before the procedure, so most patients feel only mild discomfort." },
        { q: "How many sessions are required?", a: "Typically 3–6 sessions are recommended depending on the skin concern." },
        { q: "Is there any downtime?", a: "Mild redness may occur for 1–2 days after the treatment, similar to mild sunburn." },
        { q: "When will I see results?", a: "Visible improvement usually starts after a few sessions as collagen production increases." }
      ]}
    />
  );
}